/**
 * "Înapoi în magazinul online" leaves the Black Friday view for the normal
 * shop; for the rest of the visit the shop's entry points (header link, bare
 * product list) then stay in the normal shop. Every new sign-in clears the
 * flag, so the next visit to the shop opens the Black Friday view again.
 */
const LEFT_BF_VIEW_KEY = "blackFriday2026LeftForNormalShop"

export const markLeftBlackFridayView = () => {
  try {
    sessionStorage.setItem(LEFT_BF_VIEW_KEY, "true")
  } catch (e) {}
}

export const hasLeftBlackFridayView = () => {
  try {
    return sessionStorage.getItem(LEFT_BF_VIEW_KEY) === "true"
  } catch (e) {
    return false
  }
}

export const clearLeftBlackFridayView = () => {
  try {
    sessionStorage.removeItem(LEFT_BF_VIEW_KEY)
  } catch (e) {}
}
